// Câmbio USD→BRL para contas em dólar.
// A cotação vem da awesomeapi (mesma fonte do widget do Dashboard) com fallback
// na open.er-api.com (mesma dupla usada em functions/index.js pros investimentos).
// O último valor buscado fica em localStorage pra funcionar offline/na primeira
// renderização — o fetch atualiza em background e o state re-renderiza depois.

const STORAGE_KEY = 'maw_usd_rate';
const DEFAULT_RATE = 5.5; // usado só se nunca houve fetch bem-sucedido

export function getCachedUsdRate() {
  try {
    const v = parseFloat(localStorage.getItem(STORAGE_KEY));
    if (v > 0) return v;
  } catch {}
  return DEFAULT_RATE;
}

export async function fetchUsdRate() {
  try {
    const d = await (await fetch('https://economia.awesomeapi.com.br/last/USD-BRL')).json();
    const r = parseFloat(d?.USDBRL?.bid);
    if (r > 0) { try { localStorage.setItem(STORAGE_KEY, String(r)); } catch {} return r; }
  } catch {}
  try {
    const d = await (await fetch('https://open.er-api.com/v6/latest/USD')).json();
    const r = parseFloat(d?.rates?.BRL);
    if (r > 0) { try { localStorage.setItem(STORAGE_KEY, String(r)); } catch {} return r; }
  } catch {}
  return getCachedUsdRate();
}

// Converte um valor na moeda dada para BRL pela cotação informada
export const toBRL = (value, currency, usdRate) =>
  currency === 'USD' ? value * usdRate : value;

// Soma os saldos das contas ativas já convertidos pra BRL.
// É a fonte única do "Saldo Total" — Dashboard, Contas, Saúde Financeira etc.
export const sumAccountsBRL = (accounts, usdRate) =>
  accounts.filter(a => a.active).reduce((s, a) => s + toBRL(a.balance, a.currency, usdRate), 0);
